import { createAsyncActionTypes } from 'misc/utils';

export const LOGIN = createAsyncActionTypes('auth/LOGIN');
export const REFRESH = createAsyncActionTypes('auth/REFRESH');
export const PASSWORD_CHANGE = createAsyncActionTypes('users/PASSWORD_CHANGE');
export const LOGOUT = 'auth/LOGOUT';
export const AUTHORIZE = 'auth/AUTHORIZE';
